<template>
  <div class="mit-new-reserve-buttons">
    <v-menu offset-y v-if="linkBuilding32 && linkBuilding45" >
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" v-bind="attrs"v-on="on">
          <v-icon class="pr-2">mdi-calendar-plus</v-icon>{{buttonText}}
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <a v-if="linkBuilding32IsLocal" style="text-decoration: none;">
            <v-btn :to="linkBuilding32" block text elevation="0" color="primary">{{ linkBuilding32Text }}<v-icon class="mx-5">mdi-arrow-right</v-icon></v-btn>
          </a>
          <a v-else style="text-decoration: none;" target="_blank" rel="noopener noreferrer" :href="linkBuilding32">
            <v-btn block text elevation="0" color="primary">{{ linkBuilding32Text }}<v-icon class="mx-5">mdi-open-in-new</v-icon></v-btn>
          </a>
        </v-list-item>
        <v-list-item>
          <a style="text-decoration: none;" target="_blank" rel="noopener noreferrer" :href="linkBuilding45">
            <v-btn block text elevation="0" color="primary">{{ linkBuilding45Text }}<v-icon class="mx-5"> mdi-open-in-new</v-icon></v-btn>
          </a>
        </v-list-item>
      </v-list>
    </v-menu>
    <a v-else-if="linkBuilding32" class="pr-2" target="_blank" rel="noopener noreferrer" :href="linkBuilding32">
      <v-btn small elevation="0" color="primary"><v-icon class="pr-1">mdi-calendar-plus</v-icon>{{buttonText}}<v-icon class="mx-5"> mdi-open-in-new</v-icon></v-btn>
    </a>
    <a v-else-if="linkBuilding45" target="_blank" rel="noopener noreferrer" :href="linkBuilding45">
      <v-btn small elevation="0" color="primary"><v-icon class="pr-1">mdi-calendar-plus</v-icon>{{buttonText}}<v-icon class="mx-5"> mdi-open-in-new</v-icon></v-btn>
    </a>
  </div>
</template>

<script>
import BaseMitConfigService from '../../services/BaseMitConfigService.js';
export default {
  name: 'BaseMitNewReserveButtons',
  components: {
  },
  props: {
    buttonText:{
        default () {
          return 'New';
        },
        type: String
    },
    linkBuilding32Text:{
        default () {
          return 'Reserve in Building 32';
        },
        type: String
    },
    //This is used for the reserve app so that it will internally route using the :to vue-router
    linkBuilding32IsLocal:{
      default () {
          return false;
        },
        type: Boolean
    },
    linkBuilding45Text:{
        default () {
          return 'Reserve in Building 45';
        },
        type: String
    }
  },
  data: function() {
    return {
        linkBuilding32:null,
        linkBuilding45:null
    }
  },
  mounted() {
      this.linkBuilding32 = BaseMitConfigService.get('CLIENT_RESERVE_NEW_32');
      this.linkBuilding45 = BaseMitConfigService.get('CLIENT_RESERVE_NEW_45');
  },
  methods : {
  }
}
</script>

<style lang="scss" scoped>
    
</style>
